const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/spiral-binding-machines`,
    saveSpeedTable: `${API_URL}/spiral-binding-machine/save-speed-table`
};

export default apiUrls;
